import React from "react";
import { FiArrowUpRight, FiGithub } from "react-icons/fi";
import Reveal, { RevealMedia } from "./Reveal";

const Work = ({ projects }) => (
  <section className="act work" id="work">
    <div className="act__inner">
      <Reveal>
        <span className="act__num">01 — Projeler</span>
      </Reveal>
      <Reveal as="h2" className="act__title" delay={0.05}>
        Bir zamanlar yaptığım <em>uygulamalar</em>
      </Reveal>
      <Reveal as="p" className="act__lead" delay={0.1}>
        Bu uygulamalar, okul döneminden sonra kendimi geliştirmek için
        yaptığım kişisel projeler ve freelance olarak geliştirdiğim uygulamalardan
        oluşuyor.
      </Reveal>
      <Reveal as="p" className="act__lead" delay={0.1}>
        Çalıştığım şirketlerde geliştirdiğim uygulamaları burada paylaşmıyorum.
      </Reveal>

      <div className="work__list">
        {projects.map((p) => (
          <Reveal className="work__item" key={p.title}>
            <div className="work__body">
              <p className="work__meta" lang="en">
                {p.year} · {p.platform} · {p.tech.slice(0, 3).join(" / ")}
              </p>
              <h3 className="work__name">{p.title}</h3>
              <p className="work__desc">{p.description}</p>
              <div className="work__tags" lang="en">
                {p.tech.map((t) => (
                  <span className="work__tag" key={t}>
                    {t}
                  </span>
                ))}
              </div>
              <div className="work__links" lang="en">
                {p.demoLink && p.demoLink !== "#" && (
                  <a
                    className="work__link"
                    href={p.demoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FiArrowUpRight aria-hidden="true" /> Demo
                  </a>
                )}
                {p.githubLink && p.githubLink !== "#" && (
                  <a
                    className="work__link"
                    href={p.githubLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FiGithub aria-hidden="true" /> Kod
                  </a>
                )}
              </div>
            </div>
            <RevealMedia className="work__media">
              <img
                src={p.image}
                alt={`${p.title} ekran görüntüsü`}
                loading="lazy"
              />
            </RevealMedia>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Work;
